<template>
    <section class="home-hero" v-bind:[attributes.componentId]="type.id" >
        <div class="text-container">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-7">
                        <h1 class="title" v-bind:[attributes.elementCodename]="type.elements.title.codename">
                            {{ title }}
                        </h1>
                        <h3 class="subtitle" v-bind:[attributes.elementCodename]="type.elements.subtitle.codename">
                            {{ subtitle }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="video-overlay" v-if="videoOverlay.length > 0" v-bind:[attributes.elementCodename]="type.elements.video_overlay.codename">
            <NuxtImg provider="kontentAiProvider" :src="videoOverlay" />
        </div>
        <div class="video-container" v-if="video.length > 0" v-bind:[attributes.elementCodename]="type.elements.video.codename">
            <video width="100%" height="100%" preload="auto" autoplay loop muted playsinline>
                <source :src="video" type="video/mp4">
            </video>
        </div>
        <div class="mobile-img" v-if="mobileImage.length > 0" v-bind:[attributes.elementCodename]="type.elements.mobile_image.codename">
            <NuxtImg provider="kontentAiProvider" :src="mobileImage" />
        </div>
    </section>
</template>

<script setup lang="ts">
import { contentTypes, type HomepageHeroModel } from '~/models';

const props = defineProps<{ model: HomepageHeroModel }>();
const title = ref('');
const subtitle = ref('');
const mobileImage = ref('');
const video = ref('');
const videoOverlay = ref('');
title.value = props.model?.elements?.title?.value ?? '';
subtitle.value = props.model?.elements?.subtitle?.value ?? '';
if ((props.model?.elements?.mobileImage?.value?.length ?? 0) > 0)
    mobileImage.value = props.model?.elements?.mobileImage?.value?.[0]?.url ?? '';

if ((props.model?.elements?.video?.value?.length ?? 0) > 0)
    video.value = props.model?.elements?.video?.value?.[0]?.url ?? '';

if ((props.model?.elements?.videoOverlay?.value?.length ?? 0) > 0)
    videoOverlay.value = props.model?.elements?.videoOverlay?.value?.[0]?.url ?? '';

const attributes = GetKontentAttributes();
const type = contentTypes._homepage_hero;

</script>

<style lang="scss" scoped></style>